import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NAVIGATION_ITEM_MOVING_STRATEGIES,
  navigationItemMovingStrategies
} from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-moving-strategies';
import { NAVIGATION_ITEM_FLAT_TREE_CONFIG } from '@/app/platform/platform-shared/navigation-item-tree/types';
import { navigationItemFlatTreeConfig } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-tree-configs';
import { TreeItemEditorComponent } from '@/app/platform/platform-shared/navigation-item-tree/tree-item-editor/tree-item-editor.component';
import { FormsModule } from '@angular/forms';
import { TreeViewToolsComponent } from '@/app/platform/platform-shared/navigation-item-tree/tree-view-tools/tree-view-tools.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [TreeItemEditorComponent, TreeViewToolsComponent],
  imports: [CommonModule, FormsModule, TranslocoModule, SharedModule],
  exports: [TreeItemEditorComponent, TreeViewToolsComponent],
  providers: [
    {
      provide: NAVIGATION_ITEM_MOVING_STRATEGIES,
      useValue: navigationItemMovingStrategies
    },
    {
      provide: NAVIGATION_ITEM_FLAT_TREE_CONFIG,
      useValue: navigationItemFlatTreeConfig
    }
  ]
})
export class NavigationItemTreeModule {}
